import { useState } from "react";
import { FiShoppingCart, FiX } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DefaultImage from "../../assets/png/defaultImage.png";
import { removeFromCart } from "../../redux/slices/cart/cartSlice";
import { dispatch } from "../../redux/store";
import { Modal } from "../shared/Modal";

const CartSheet = ({
  removeOpen,
  setRemoveOpen,
  handleRemoveClick,
}: {
  removeOpen: boolean;
  setRemoveOpen: any;
  handleRemoveClick: any;
}) => {
  const { cartItems } = useSelector((state: any) => state.cart);
  console.log("🚀 ~ cartItems:", cartItems)
  const { auth } = useSelector((state: any) => state.auth);
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState<any>(null);

  // Total Price (without tax)
  const total = cartItems?.reduce((acc: any, item: any) => {
    const itemPrice = parseFloat(
      item.branchProductListResponse?.sellingPriceWithTax || "0"
    );
    const itemQuantity = item.quantity || 1;
    return acc + itemPrice * itemQuantity;
  }, 0);

  return (
    <>
      <div className="flex flex-col w-full h-full gap-4 bg-white shadow-md rounded-lg">
        {/* Header */}
        <div
          className="font-semibold text-[#1A1A1A] text-lg px-4 py-3 border-b"
          style={{
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: "20px",
            lineHeight: "30px",
          }}
        >
          Shopping Cart {cartItems.length > 0 && `(${cartItems.length})`}
        </div>

        {/* Cart Items */}
        {auth ? (
          <>
            {cartItems.length > 0 ? (
              <>
                <div className="flex-grow overflow-y-auto px-4 gap-4">
                  {cartItems.map((item: any) => {
                    return (
                      <div
                        key={item.id}
                        className="flex items-center gap-4 py-2 border-b"
                      >
                        {/* Product Image */}
                        <div className="w-16 h-16">
                          <img
                            src={
                              item?.branchProductListResponse?.image ??
                              DefaultImage
                            }
                            alt={item?.branchProductListResponse?.name}
                            className="w-full h-full object-contain rounded-md"
                          />
                        </div>

                        {/* Product Info */}
                        <div className="flex flex-col flex-grow gap-1">
                          <div
                            className="text-sm font-medium text-gray-800"
                            style={{
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "14px",
                              lineHeight: "21px",
                              color: "#1A1A1A",
                            }}
                          >
                            {item?.branchProductListResponse?.name}
                          </div>

                          <div
                            className="flex items-center text-sm text-gray-600"
                            style={{
                              height: "21px",
                              gap: "4px",
                            }}
                          >
                            <span
                              style={{
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "14px",
                                lineHeight: "21px",
                                color: "#808080",
                              }}
                            >
                              {item?.quantity} x
                            </span>

                            <span
                              className="text-gray-800 font-medium"
                              style={{
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "14px",
                                lineHeight: "16.8px",
                                color: "#1A1A1A",
                              }}
                            >
                              £
                              {parseFloat(
                                item?.branchProductListResponse?.sellingPriceWithTax ||
                                  "0"
                              ).toFixed(2)}
                            </span>
                          </div>
                        </div>

                        {/* X Icon */}
                        <button
                          className="text-gray-400 transition-all hover:text-red-500"
                          onClick={() => handleRemoveClick(item)}
                          aria-label="Remove item"
                        >
                          <FiX className="w-5 h-5" />
                        </button>
                      </div>
                    );
                  })}
                </div>

                {/* Footer */}
                <div className="px-5 py-4 border-t">
                  <div className="flex flex-col gap-3 text-gray-700">
                    {/* Total Price */}
                    <div className="flex justify-between">
                      <span
                        className="text-[16px] leading-[24px] font-normal text-[#1A1A1A]"
                        style={{ fontFamily: "Poppins" }}
                      >
                        Total Price
                      </span>
                      <span
                        className="text-lg leading-[19.2px] font-Poppins text-[#1A1A1A] text-[16px] font-semibold"
                        style={{ fontFamily: "Poppins" }}
                      >
                        £{total.toFixed(2)}
                      </span>
                    </div>
                  </div>

                  <div className="flex flex-col gap-3 mt-3">
                    <button
                      onClick={() => navigate("/checkout")}
                      className="bg-[#00B207] text-white py-2 rounded-full text-center font-semibold hover:bg-[#008f05] transition hover:opacity-70 "
                    >
                      Checkout
                    </button>
                    <button
                      onClick={() => navigate("/cart")}
                      className="bg-[#0507051a] text-[#56AC59] py-2 rounded-full text-center font-semibold hover:bg-[#56AC591F] transition hover:opacity-70 "
                    >
                      Go To Cart
                    </button>
                  </div>
                </div>
              </>
            ) : (
              // Empty Cart State
              <div className="flex-grow flex flex-col justify-center items-center text-gray-500">
                <FiShoppingCart className="text-6xl mb-2" />
                <div className="font-semibold text-lg">Your cart is empty!</div>
              </div>
            )}
          </>
        ) : (
          <div className="flex-grow flex flex-col justify-center items-center text-gray-500">
            <div className="font-semibold text-lg">
              Login to add products to your cart!
            </div>
          </div>
        )}
      </div>
      {/* Remove Confirmation Modal */}
    </>
  );
};

export default CartSheet;
